import React from 'react';
import { Card, CardContent } from '@/components/ui/Card';
import { useInView } from '@/hooks/useInView';

export const Testimonials: React.FC = () => {
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
  
  return (
    <section ref={ref} className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Titre avec style cohérent */}
        <div className="mb-16">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3 leading-tight uppercase">
            Des résultats concrets pour nos utilisateurs
          </h2>
          <div className="w-12 h-0.5 bg-blue-500 mb-6"></div>
          <p className="text-lg text-gray-600 max-w-4xl">
            Découvrez comment DPEWizard aide les propriétaires et professionnels à optimiser leurs investissements énergétiques
          </p>
        </div>

        {/* Visuel des témoignages - sans cadre */}
        <div className="mb-16">
          <img 
            src="/assets/DPEWizard_testimonials_nonretina.png"
            srcSet="/assets/DPEWizard_testimonials_nonretina.png 1x, /assets/DPEWizard_testimonials_Retina.png 2x"
            alt="Témoignages clients DPEWizard - Retours d'expérience sur l'optimisation énergétique"
            className="w-full h-auto object-contain mx-auto"
            loading="lazy"
          />
        </div>

        {/* Métriques de performance */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">1000+</div>
            <div className="text-sm text-gray-600 font-medium">DPE analysés</div>
          </div>
          <div className="text-center">
            <div className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">95%</div>
            <div className="text-sm text-gray-600 font-medium">Précision détection</div>
          </div>
          <div className="text-center">
            <div className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">28</div>
            <div className="text-sm text-gray-600 font-medium">Règles expertes</div>
          </div>
          <div className="text-center">
            <div className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">2min</div>
            <div className="text-sm text-gray-600 font-medium">Temps moyen analyse</div>
          </div>
        </div>

        {/* Message de conclusion */}
        <div className="mt-12 text-center">
          <p className="text-lg font-medium text-gray-700 max-w-3xl mx-auto">
            Rejoignez des centaines de propriétaires qui optimisent leurs travaux énergétiques avec DPEWizard
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;